/* Fibrelo "Try your luck" popup: 1:1 rebuild of Alia flow 363727 (templates from game/render.py).
   window.FIB_GAME = {tpl, assets:{name:url}, sf:{token, ver}} is set by snippets/fib-game.liquid. */
(function () {
  'use strict';
  if (window.__fibGame) return; window.__fibGame = 1;
  var G = window.FIB_GAME, T = G && G.tpl; if (!T) return;
  var ORDER = T.order, S = {pick: ORDER[0], quiz: ORDER[1], email: ORDER[2], phone: ORDER[3], verify: ORDER[4],
                            apply: ORDER[5], returning: ORDER[6], float: ORDER[7]};
  var KEY = 'fib_game_v1', DAY = 864e5, ROOT_ID = 'alia-root-363727';
  var st = load(), root = null, cur = null, lay = null, picks = [], deskMQ = window.matchMedia('(min-width: 1024px)');

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} }
  function A(h) { return h.replace(/@@A:([^@]+)@@/g, function (m, n) { return G.assets[n] || ''; }); }
  function J(el, a) { try { return JSON.parse(el.getAttribute(a) || '[]'); } catch (e) { return []; } }

  /* ---------- render ---------- */
  function mount(stepId) {
    var s = T.steps[stepId], lid = s.layouts[deskMQ.matches ? '1024' : 'default'], L = T.layouts[lid];
    if (!root) {
      root = document.createElement('div'); root.id = ROOT_ID; root.tabIndex = -1;
      document.body.appendChild(root);
    }
    if (s.float) {
      root.setAttribute('style', 'position: fixed; outline: none; display: block; z-index: 2147483647;');
      root.removeAttribute('aria-modal'); root.removeAttribute('role'); root.setAttribute('aria-label', 'Promotional popup');
    } else {
      root.setAttribute('style', 'position: fixed; outline: none; display: block; inset: 0px; width: 100%; height: 100%; z-index: 2147483647;');
      root.setAttribute('aria-modal', 'true'); root.setAttribute('role', 'dialog'); root.setAttribute('aria-label', 'Promotional popup');
    }
    if (lay !== lid) {
      root.innerHTML = '<div id="alia-popup-root-' + L.root + '" class="w-full h-full fib-popup-root"><div class="fixed top-4 w-80 max-h-16 overflow-hidden p-4 '
        + 'bg-accent-900 text-accent-foreground rounded-lg transition-all duration-200 ease-in shadow-lg pointer-events-none" style="z-index: 2147483647; left: 50%; '
        + 'transform: translateX(-50%) translateY(-8rem); opacity: 0;"></div>' + A(L.html.replace('@@OUTLET@@', '<!--fib-outlet-->')) + '</div>';
      if (s.float) { var lr = root.querySelector('[data-fib-layout]'); lr.style.position = 'fixed'; }
      lay = lid;
    }
    var anchor = outlet(); if (!anchor) return;
    var n = anchor.nextSibling;
    while (n && !(n.nodeType === 8 && n.data === 'fib-outlet-end')) { var x = n.nextSibling; n.parentNode.removeChild(n); n = x; }
    if (!n) { n = document.createComment('fib-outlet-end'); anchor.parentNode.insertBefore(n, anchor.nextSibling); }
    var tmp = document.createElement('div'); tmp.innerHTML = A(s.html);
    while (tmp.firstChild) n.parentNode.insertBefore(tmp.firstChild, n);
    cur = stepId; picks = [];
    if (!s.float) { st.recent = stepId; save(); }
    lockScroll(!s.float && !deskMQ.matches);
    wire();
    if (stepId === S.apply) markDone();
  }
  function outlet() {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_COMMENT), c;
    while ((c = w.nextNode())) if (c.data === 'fib-outlet') return c;
  }
  function unmount() { if (root) root.remove(); root = null; lay = null; cur = null; lockScroll(false); }
  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  /* ---------- actions (Alia action objects) ---------- */
  function exec(acts) {
    (acts || []).forEach(function (a) {
      if (a.type === 'step') go(a.step);
      else if (a.type === 'closePopup') {
        unmount(); st.closed = Date.now(); st.float = 0; save();
        if (a.redirect && a.redirect.path && location.pathname !== T.redirect) location.href = T.redirect;
      } else if (a.type === 'floatingButton') { st.float = 1; save(); mount(a.stepID); }
    });
  }
  function go(step) {
    var id;
    if (step.type === 'next') id = ORDER[ORDER.indexOf(cur) + 1];
    else if (step.type === 'step') id = step.stepID;
    else if (step.type === 'mostRecent') id = st.recent || step.otherwise;
    if (id === S.verify) id = S.apply;          // no SMS provider on our side: OTP step skipped
    if (st.float && !T.steps[id].float) { st.float = 0; save(); }
    if (id) mount(id);
  }

  /* ---------- wiring per step ---------- */
  function wire() {
    root.querySelectorAll('[data-fib-act]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (el.matches('form button[type=submit]')) return;
        e.preventDefault(); e.stopPropagation();
        if (el.hasAttribute('data-fib-answer')) { st.quiz = el.getAttribute('data-fib-answer'); save(); }
        exec(J(el, 'data-fib-act'));
      });
      if (el.getAttribute('role') === 'button') el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); } });
    });
    var pick = root.querySelector('[data-fib-pick]'); if (pick) wirePick(pick);
    root.querySelectorAll('form[data-fib-form]').forEach(wireForm);
  }

  function wirePick(grid) {
    var offers = J(grid, 'data-fib-pick'), need = Math.max(1, offers.length), done = false;
    var status = grid.parentNode.querySelector('[role=status] span');
    grid.querySelectorAll(':scope > [role=button]').forEach(function (card) {
      var inner = card.firstElementChild, face = card.querySelector('[data-card-side=cardFace] > div');
      function can() { return picks.length < need && picks.indexOf(card) < 0; }
      function lift(on) {
        var l = on && can();
        card.style.transform = l ? 'translateY(-6px) scale(1.04)' : '';
        card.style.filter = l ? 'drop-shadow(0 10px 16px rgba(0,0,0,0.18))' : '';
      }
      card.addEventListener('pointerenter', function () { lift(true); });
      card.addEventListener('pointerleave', function () { lift(false); });
      card.addEventListener('click', function () {
        if (!can()) return;
        var txt = offers[picks.length] || ''; picks.push(card);
        face.innerHTML = '<p>' + txt + '</p>';
        inner.style.transform = 'rotateY(180deg)';
        card.setAttribute('aria-pressed', 'true'); card.setAttribute('aria-label', txt); lift(false);
        if (status) status.textContent = txt;
        if (picks.length >= need) {
          grid.querySelectorAll(':scope > [role=button]').forEach(function (c) {
            if (picks.indexOf(c) < 0) { c.setAttribute('aria-disabled', 'true'); c.tabIndex = -1; c.style.cursor = 'default'; }
          });
          if (!done) { done = true; setTimeout(function () { exec(J(grid, 'data-fib-after')); }, 750); }
        }
      });
    });
  }

  function wireForm(f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = f.querySelector('button[type=submit]'), em = f.querySelector('input[name=email]'), ph = f.querySelector('input[name=phone]'), job;
      if (em) {
        var v = em.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return bad(em, 'Please enter a valid email address');
        st.email = v; save(); job = createCustomer(v);
      } else if (ph) {
        var d = ph.value.replace(/\D/g, ''); if (d.length === 11 && d[0] === '1') d = d.slice(1);
        if (d.length !== 10) return bad(ph, 'Please enter a valid phone number');
        st.phone = '+1' + d; save(); job = addPhone(st.phone);
      }
      if (btn) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); }
      Promise.resolve(job).catch(function () {}).then(function () { exec(J(f, 'data-fib-after')); });
    });
  }
  function bad(inp, msg) {
    inp.classList.add('alia-error'); inp.setAttribute('aria-invalid', 'true'); inp.focus();
    var t = root.querySelector('.fib-popup-root > .fixed');
    if (t) { t.textContent = msg; t.style.transform = 'translateX(-50%) translateY(0)'; t.style.opacity = '1';
             setTimeout(function () { t.style.transform = 'translateX(-50%) translateY(-8rem)'; t.style.opacity = '0'; setTimeout(function () { t.textContent = ''; }, 300); }, 2500); }
    inp.addEventListener('input', function () { inp.classList.remove('alia-error'); inp.removeAttribute('aria-invalid'); }, {once: true});
  }

  /* ---------- Shopify: customer (email consent + phone + quiz goal) ---------- */
  var GOAL = {"I'm on a GLP-1 but I don't feel great": 'glp1', 'I want an easy nutrition solution': 'easy-nutrition',
              'I need gut health support': 'gut-health', 'I want to avoid an afternoon slump': 'afternoon-slump'};
  function sf(q, v) {
    return fetch('/api/' + G.sf.ver + '/graphql.json', {method: 'POST', headers: {'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': G.sf.token}, body: JSON.stringify({query: q, variables: v})}).then(function (r) { return r.json(); });
  }
  function token() {
    return sf('mutation($e:String!,$p:String!){customerAccessTokenCreate(input:{email:$e,password:$p}){customerAccessToken{accessToken}}}',
              {e: st.email, p: st.pw}).then(function (r) { var t = r.data.customerAccessTokenCreate.customerAccessToken; return t && t.accessToken; });
  }
  function createCustomer(email) {
    var pw = st.pw || (st.pw = 'Fg!' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)); save();
    return sf('mutation($i:CustomerCreateInput!){customerCreate(input:$i){customer{id} customerUserErrors{code}}}',
              {i: {email: email, password: pw, acceptsMarketing: true}}).then(function (r) {
      var c = r && r.data && r.data.customerCreate; st.cust = c && c.customer ? 'new' : ((c && c.customerUserErrors[0] || {}).code || 'err'); save();
      if (st.cust !== 'new') return;
      // the storefront can't write tags: leave a marker address that game/tag_sync.py (Admin API) turns into tags, then deletes
      return token().then(function (t) {
        if (!t) return;
        return sf('mutation($t:String!,$a:MailingAddressInput!){customerAddressCreate(customerAccessToken:$t,address:$a){customerUserErrors{code}}}',
                  {t: t, a: {address1: 'fib-game', company: 'goal:' + (GOAL[st.quiz] || 'none'), country: 'United States'}});
      });
    });
  }
  function addPhone(phone) {
    if (st.cust !== 'new' || !st.email) return;
    return token().then(function (t) {
      if (!t) return;
      return sf('mutation($t:String!,$c:CustomerUpdateInput!){customerUpdate(customerAccessToken:$t,customer:$c){customerUserErrors{code}}}',
                {t: t, c: {phone: phone}}).then(function (r) {
        if ((r.data.customerUpdate.customerUserErrors || []).length) return;
        // shopper agreed to the text-message consent wording: marker for game/tag_sync.py -> smsMarketingConsent SUBSCRIBED
        return sf('mutation($t:String!,$a:MailingAddressInput!){customerAddressCreate(customerAccessToken:$t,address:$a){customerUserErrors{code}}}',
                  {t: t, a: {address1: 'fib-game-sms', company: 'sms-consent', country: 'United States'}});
      });
    });
  }
  function markDone() { st.done = 1; st.float = 0; save(); subInCart(false); }

  /* ---------- the prize = Subscribe & Save ($29.99 vs $66.65) put in the cart at "Discount Applied!"; /pages/surprise opens the drawer ---------- */
  function subInCart(open) {
    var V = window.FIB && window.FIB.v; if (!V) return;
    var otp2sub = {};
    ['LS', 'SF'].forEach(function (g) { ['28', '84'].forEach(function (z) { otp2sub[V.otp[g][z]] = V.sub[g][z]; }); });
    var j = function (u, b) { return fetch(u, b ? {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(b)} : {}).then(function (r) { return r.json(); }); };
    j('/cart.js').then(function (c) {
      var swaps = c.items.filter(function (i) { return otp2sub[i.variant_id]; });
      if (!c.items.length) return j('/cart/add.js', {items: [{id: V.sub.LS['28'], quantity: 1}]});
      var upd = {}; swaps.forEach(function (i) { upd[i.key] = 0; });
      if (!swaps.length) return;
      return j('/cart/update.js', {updates: upd}).then(function () {
        return j('/cart/add.js', {items: swaps.map(function (i) { return {id: otp2sub[i.variant_id], quantity: i.quantity}; })});
      });
    }).then(function () {
      st.carted = 1; save();
      if (window.FIB_DRAWER) window.FIB_DRAWER[open ? 'open' : 'refresh']();
    });
  }

  /* ---------- trigger (Alia: timeOnPage 2s, again after 1 day, floating button persists) ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root && cur && !T.steps[cur].float) { var x = root.querySelector('[aria-label="Close popup"]'); if (x) x.click(); }
  });
  deskMQ.addEventListener && deskMQ.addEventListener('change', function () { if (cur) { var c = cur; lay = null; mount(c); } });
  window.FIB_GAME.open = function (step) { mount(step || S.pick); };
  var now = Date.now();
  if (/[?&]fib_game=reset/.test(location.search)) { st = {}; save(); }
  if (/[?&]fib_game=off/.test(location.search)) return;   // clean screenshots
  if (st.done) {
    if (location.pathname === T.redirect && !st.shownCart) { st.shownCart = 1; save(); subInCart(true); }
    return;
  }
  if (st.shown && now - st.shown < DAY) { if (st.float && !st.closed) mount(S.float); return; }
  setTimeout(function () {
    if (root) return;
    st = {pw: st.pw, email: st.email, cust: st.cust, shown: Date.now()}; save();
    mount(S.pick);
  }, 2000);
})();
